import { fetchApi, trackError } from '@vend/utilities'

export type RepeatPaymentMethodResult = {
  orderId: string
  repeatCardOccurrenceCount: number
  brand: string | null
  last4: string | null
  isSaved: boolean
}

export const fetchRepeatPaymentMethodCheck = async (
  saleLocalId: string,
  retailerId: string,
  outletId: string
): Promise<RepeatPaymentMethodResult> => {
  try {
    const response = await fetchApi(
      `/api/2.0/lspay/processing/v1/merchants/${retailerId}/payment-fingerprint-repeats/${saleLocalId}`,
      {
        method: 'GET',
        headers: {
          'x-lspay-pli': 'lsx:' + outletId,
          'Content-Type': 'application/json',
        },
      }
    )
    const data = await response.json()

    const saleLocalIdMatches = data?.paymentReferenceId === saleLocalId

    if (!saleLocalIdMatches) {
      trackError('[LSPayRepeatPaymentDetection] SaleLocalId mismatch', {
        data: {
          paymentReferenceId: data?.paymentReferenceId,
          saleLocalId,
          retailerId,
        },
      })
      return {
        orderId: saleLocalId,
        repeatCardOccurrenceCount: 0,
        brand: null,
        last4: null,
        isSaved: false,
      }
    }

    const repeatCardData: RepeatPaymentMethodResult = {
      orderId: data.paymentReferenceId,
      repeatCardOccurrenceCount: data?.repeatCardOccurrenceCount ?? 0,
      brand: data?.brand ?? null,
      last4: data?.last4 ?? null,
      isSaved: data?.isSaved ?? false,
    }
    return repeatCardData
  } catch (error) {
    trackError(
      '[LSPayRepeatPaymentDetection] Failed to fetch repeat payment method data',
      {
        data: {
          error,
          saleLocalId,
          retailerId,
        },
      }
    )

    // Return an empty object for UI
    return {
      orderId: saleLocalId,
      repeatCardOccurrenceCount: 0,
      brand: null,
      last4: null,
      isSaved: false,
    }
  }
}
